<br>{{module_item_id}}
<form [formGroup]="teamForm" *ngIf="teamForm" class="px-10" (submit)="submit()">
  <div class="row">
      <div class="col-3">
        <div class="row mb-1">
          <div class="col-12">
            <label for="formGroupExampleInput"><small>Auftragsbuch (Kunden)</small></label>
            <select class="form-control"  id="customer_id" name="customer_id" formControlName="customer_id" [ngClass]="{ 'is-invalid': submitted && f['customer_id'].errors }">
              <option [ngValue]=null>bitte auswählen</option>
              <option *ngFor="let customer of orderList" [ngValue]="customer.id">{{customer.company}}</option>
            </select>
            <div *ngIf="submitted && f['customer_id'].errors">
              <div *ngIf="f['customer_id'].errors['required']" class="text-red-500">Kunde wird benötigt</div>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-12">
            <label for="formGroupExampleInput"><small>Standort</small></label>
            <select class="form-control"  id="customer_branch_id" name="customer_branch_id" formControlName="customer_branch_id" [ngClass]="{ 'is-invalid': submitted && f['customer_branch_id'].errors }">
              <option [ngValue]=null>bitte auswählen</option>
              <option *ngFor="let customerBranch of customerBranchList" [ngValue]="customerBranch.id">{{customerBranch.title}}</option>
            </select>
            <div *ngIf="submitted && f['customer_branch_id'].errors">
              <div *ngIf="f['customer_branch_id'].errors['required']" class="text-red-500">Standort wird benötigt</div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="col-9">
  
        <div class="row mb-1">
          <div class="col">
            <label for="formGroupExampleInput"><small>Bezeichnung</small></label>
            <input type="text" class="form-control" id="label" name="label" formControlName="label">
          </div>
        
          <div class="col">
            <label for="formGroupExampleInput"><small>Identifikation</small></label>
            <input type="text" class="form-control" id="identity" name="identity"  [ngClass]="{ 'is-invalid': submitted && f['identity'].errors }" formControlName="identity">
            <div *ngIf="submitted && f['identity'].errors">
              <div *ngIf="f['identity'].errors['required']" class="text-red-500">Vorname wird benötigt</div>
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col">
            <label for="formGroupExampleInput"><small>Phone</small></label>
            <input type="text" class="form-control" id="phone" name="phone" formControlName="phone">
          </div>
        </div>   
     </div>   
  </div>
<br>
  


  

  <button type="submit" class="btn btn-success">speichern</button>
  <button type="button" class="btn btn-success ml-1" (click)="addDummyData()">add dummydata</button>
</form>

